import React from 'react';
import axios from 'axios';
import { Form, Input, Select, Alert, Radio, message } from 'antd';

import apiPath from 'apiPath';
import withSpin from 'components/withSpin';
import stickyError from 'components/stickyError';
import SaveButton from 'components/SaveButton';

class GenderIdentity extends React.Component {
	state = {
		submitting: false,
		options: [
			'','Agender','Androgynous','Bigender','Cisgender Female','Cisgender Male','Female',
			'Female to Male (FTM)','Gender Fluid','Gender Nonconforming','Gender Questioning',
			'Gender Variant','Genderqueer','Intersex','Male','Male to Female','Neither',
			'Non-binary','Pangender','Trans Person','Transgender','Not Listed'
		]
	}
	handleSubmit = (event) => {
		event.preventDefault();
		this.props.isSubmitting();
		this.props.form.validateFields((err, values) => {
			if (err) {
				this.props.isSubmitted();
				return stickyError(err.message);
			}
			const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'GENDERID');
			const data = Object.assign({}, values, (matchingRemark)?{id:matchingRemark.AssignId}:{});
			axios({
				method: (matchingRemark && matchingRemark.AssignId) ? 'put' : 'post',
				url: apiPath+'/remark/37',
				data: data,
				withCredentials: true
			}).then(result => {
				this.props.isSubmitted();
				this.props.refreshRemarks();
				message.success('Saved!');
			}).catch(error => {
				this.props.isSubmitted();
				this.props.handleAxiosSaveError(error);
			});
		});
	}
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'personal/gender');
		if (this.props.variant !== 'admin') {
			const redirect = this.props.redirectIfHidden(this.props, 'personal/gender');
			if (redirect) return redirect;
		}

		const matchingRemark = this.props.remarks && this.props.remarks.find(remark => remark.Code === 'GENDERID');
		const remark = Object.assign({
			rmkString1: '',
			Comments: ''
		}, matchingRemark);

		const { getFieldDecorator } = this.props.form;
		return (
			<Form className="withSpacing" onSubmit={this.handleSubmit}>
				<h3>The information below is optional</h3>
				<p>
					If you identify with a gender that is different than appears on your passport, please provide that information here. Please note, legal names and sex, as they appear on passports, are required for voyage and field program manifests. Your gender identity will be used to support you for other program needs and to help us better understand the demographic profile of SAS students.
					<br /><br />
					According to the Human Rights Campaign, Gender Identity can be defined as one's innermost concept of self as male, female, a blend of both or neither - how individuals perceive themselves and what they call themselves. One's gender identity can be the same or different from their sex assigned at birth.
					<br /><br />
					If you go by a name that is different than the one that appears on your passport, please provide it in the "Preferred Name" field in the Basic Personal Information section.
				</p>
				<Form.Item label="Gender Identity" className="inResco">
					{getFieldDecorator('identity', {
						initialValue: remark.rmkString1
					})(
						<Select disabled={disabled}>
							{this.state.options.map(o => <Select.Option key={o} value={o}>{o}</Select.Option>)}
						</Select>
					)}
				</Form.Item>
				<Form.Item label="If not listed, please specify" className="inResco">
					{getFieldDecorator('other', {
						initialValue: remark.rmkString2
					})(
						<Input disabled={disabled} />
					)}
				</Form.Item>
				<Form.Item label="Comments" className="inResco">
					{getFieldDecorator('comments', {
						initialValue: remark.Comments,
						rules: [{max: 200, message: 'Comments are too long (max 200 characters)'}]
					})(
						<Input type="textarea" disabled={disabled} />
					)}
				</Form.Item>
				<SaveButton
					disabled={!this.props.form.isFieldsTouched()}
					loading={this.state.submitting} />
			</Form>
		);
	}
}

export default withSpin(Form.create()(GenderIdentity));



// WEBPACK FOOTER //
// ./portal-components/Portal/Personal/GenderIdentity.jsx